import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { BrokerConsultantBanner } from '../../components/BrokerConsultantBanner';
import { BrokerFlightBanner } from '../../components/BrokerFlightBanner';
import { selectBrokerFlightEnabled } from '../../selectors/brokerConsultantBanner';
import { trackBannerShow } from './tracking';
import { BrokerBannerButtonContainer } from '../BrokerBannerButtonContainer';

export const BrokerSelfRequestFormBannerContainer: React.FC = () => {
  const isFlightEnabled = useSelector(selectBrokerFlightEnabled);

  // TODO: Удалить в CD-251393.
  if (isFlightEnabled) {
    return (
      <ActionAfterViewObserver callback={trackBannerShow}>
        <BrokerFlightBanner button={<BrokerBannerButtonContainer theme="fill_white_primary" />} />
      </ActionAfterViewObserver>
    );
  }

  return (
    <ActionAfterViewObserver callback={trackBannerShow}>
      <BrokerConsultantBanner button={<BrokerBannerButtonContainer />} />
    </ActionAfterViewObserver>
  );
};
